import { keyframes } from 'styled-components';

export const shimmer = keyframes`
  0% {
    opacity: .45
  }

  to {
    opacity: .9
  }
`;

export default { shimmer };
